<template>
  <iframe
      ref="Rain3D"
      id="Rain3D"
      :src="iframePath"
      :width="defaultWidth"
      :height="defaultHeight"
  ></iframe>
</template>

<script setup>
import defaultValue from "@/utils/defaultValue"
import {reactive, ref, watchEffect, watch, toRaw, onUnmounted, onMounted, onUpdated, computed} from "vue";

const {defaultWidth, defaultHeight} = defaultValue()
const props = defineProps(['sensorValue', 'effectTheme'])

const effectThemeData = reactive(props.effectTheme)
const nowTemperature = reactive(props.sensorValue)
const iframePath = ref('./Rain3D/index.html')
const isDynamicMode = ref(false)
const currentDropletsRate = ref(2)
const refreshDropletsRate = ref(0)

const Rain3D = ref(null)
const refreshTrigger = ref(null)


function refreshIframe () {
  if (refreshTrigger.value) clearRefreshTrigger()
  let refreshSec

  if (isDynamicMode.value) refreshSec = 15
  else {
    if (currentDropletsRate.value === 6) refreshSec = 10
    else if (currentDropletsRate.value === 2) refreshSec = 20
    else refreshSec = 30
  }


  refreshTrigger.value = setInterval(function () {
    let refreshData
    if (isDynamicMode.value) {
      refreshData = Object.assign(effectThemeData, {
        DropletsRate: 1 // 雨量
      })
    } else {
      if (currentDropletsRate.value > refreshDropletsRate.value) {
        refreshDropletsRate.value = (Math.random() * refreshDropletsRate.value)+ 1
        refreshData = Object.assign(effectThemeData, {
          DropletsRate: refreshDropletsRate.value  // 雨量
        })
      } else {
        refreshData = Object.assign(effectThemeData, {
          DropletsRate: currentDropletsRate.value  // 雨量
        })
      }
    }
    const iframeElement = Rain3D.value;
    if (iframeElement && iframeElement !== null) {
      iframeElement.contentWindow.setConfigs(toRaw(refreshData));
      iframeElement.contentWindow.setSensorValue(toRaw(nowTemperature))
    }
  }, refreshSec * 1000)
}

function clearRefreshTrigger () {
  if (refreshTrigger.value) clearInterval(refreshTrigger.value)
  refreshTrigger.value = null
}


watch(effectThemeData,
      (n, o) => {
        const {
          IsDynamicMode,
          DropletsRate
        } = n
        isDynamicMode.value = IsDynamicMode || false
        currentDropletsRate.value = DropletsRate || 2
      // 傳值進 iframe
      const iframeElement = Rain3D.value;
      if (iframeElement) iframeElement.contentWindow.setConfigs(toRaw(n));
    }
)

watch( nowTemperature,
     (n, o) => {
      // 傳值進 iframe
       const iframeElement = Rain3D.value;
       if (iframeElement) iframeElement.contentWindow.setSensorValue(toRaw(n));
    }
)

onMounted(() => {
  const iframeElement = Rain3D.value;
  // iframe onload
  iframeElement.onload = () => {
    iframeElement.contentWindow.setConfigs(toRaw(effectThemeData));
    iframeElement.contentWindow.setSensorValue(toRaw(nowTemperature))
    refreshIframe()
  }
})

onUnmounted(() => {
  clearRefreshTrigger()
})

</script>
